export default __webpack_public_path__ + "static/media/ic-attempted result.4be20c5e.svg";